import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../../Services/login.service';
import { HttpHeaders } from '@angular/common/http';
import { QuoteService } from 'src/app/Modules/motor/Modules/quote/Services/quote.service';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  
  isDisabled:boolean = false;
  passwordform:FormGroup;
  private passType = "password"
  private passType1 = "password"
  private passType2 = "password"

  constructor( public _global: GlobalService,private router: Router,public dialog: MatDialog,private _formbuilder: FormBuilder,private toastr: ToastrService,public loginservice:LoginService,private quoteService:QuoteService) {

    this.passwordform =this._formbuilder.group({
      oldpass:['',[Validators.required]],
      newpass :['',[Validators.required,Validators.maxLength(10)]],
      conpass :['',[Validators.required,Validators.maxLength(10)]],
    })

    this.passwordform.get("newpass").valueChanges.subscribe(res=>{
      if(res.length != 0){
        this.isDisabled = true
      }else{
        this.isDisabled = false;
      }

    })


   }

 
  ngOnInit() {
    
    //to unlock the QQ
    
    var unlock = sessionStorage.getItem('LOCK');
    if(unlock =="L"){
      
      var userName =sessionStorage.getItem('userName');
      this.quoteService.unlockQuotedetails(userName).subscribe((data:any)=>{
        
        console.log(data);
      })
    }
  //END
  }


  Submit(passwordform){ 
 var loginpassword = sessionStorage.getItem('loginpassword');
    if(this.passwordform.value.newpass == "" && this.passwordform.value.conpass =="" && this.passwordform.value.oldpass =="" ){
     
      if(this._global.selectLang == "vn" ){ 
        this.toastr.error("Vui lòng nhập các trường bắt buộc", undefined, {
          positionClass: 'toast-bottom-right',
          timeOut: 6000
        });
        }
        else{ 
          this.toastr.error("Please Enter the Mandatory Fields", undefined, {
            positionClass: 'toast-bottom-right',
            timeOut: 6000
       });
        }   
    }
    else if(this.passwordform.value.oldpass =="" || this.passwordform.value.oldpass ==undefined){
      if(this._global.selectLang == "vn" ){ 
        this.toastr.error("Vui lòng nhập mật khẩu cũ", undefined, {
          positionClass: 'toast-bottom-right',
          timeOut: 6000
        });
        }
        else{  
      this.toastr.error("Please Enter the Old Password", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
       });
        }  
  }else if(this.passwordform.value.newpass == "" ||this.passwordform.value.newpass == undefined || 
  this.passwordform.value.conpass =="" || this.passwordform.value.conpass ==undefined ){
    if(this._global.selectLang == "vn" ){ 
      this.toastr.error("Vui lòng nhập mật khẩu mới", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
      });
      }
      else{   
        this.toastr.error("Please Enter the New / Confirm Password", undefined, {
          positionClass: 'toast-bottom-right',
          timeOut: 6000
     });
      }  
  }else if(this.passwordform.value.newpass != this.passwordform.value.conpass){
    if(this._global.selectLang == "vn" ){ 
      this.toastr.error("Vui lòng xác nhận lại mật khẩu mới", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
      });
      }
      else{    
        this.toastr.error("New and Confirm Password not Match", undefined, {
          positionClass: 'toast-bottom-right',
          timeOut: 6000
     });
      } 
    }
  //   else if (this.passwordform.value.oldpass == this.passwordform.value.newpass){
  //     this.toastr.error("Old & New password cannot be same", undefined, {
  //       positionClass: 'toast-bottom-right',
  //       timeOut: 6000
  //  });
  //   }
  //   else if(this.passwordform.value.oldpass != loginpassword){
  //     this.toastr.error("Old Password does not match", undefined, {
  //       positionClass: 'toast-bottom-right',
  //       timeOut: 6000
  //   });
  //   }
    else{
      if(this.passwordform.valid){
        
        passwordform.value.userName =sessionStorage.getItem('userName'); ;
        let Form = JSON.stringify(this.passwordform.value);
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
        this.loginservice.changepassword(Form).subscribe((res: any)=>{
        console.log(res);
          
        this.dialog.closeAll();
          if(res.responseType == "SUCCESS"){
            if(res.responseBody.status == "S"){
              if(this._global.selectLang == "vn" ){ 
                this.toastr.success("Mật khẩu đã được đổi thành công", undefined, {
                  positionClass: 'toast-bottom-right',
                  timeOut: 6000
                });
                }
                else{    
                  this.toastr.success("Password Changed Successfully", undefined, {
                    positionClass: 'toast-bottom-right',
                    timeOut: 6000
                });
                } 
           this.router.navigate(["home"]);
            }
            else{
              if(this._global.selectLang == "vn" ){ 
                this.toastr.error("Mật khẩu cũ không khớp", undefined, {
                  positionClass: 'toast-bottom-right',
                  timeOut: 6000
                });
                }
                else{    
              this.toastr.error("Old Password does not match", undefined, {
                positionClass: 'toast-bottom-right',
                timeOut: 6000
                });
                }
            } 
          }
        })
      }
    }
  }

  onStrengthChanged(eve){ 
    if(eve == 100){
     this.isDisabled = false;
    }
  } 
  showPwd(){ 
    if (this.passType == "password"){
      this.passType = "text";
    }else{
      this.passType = "password";
    }
  } 
  showPwd1(){
    
    if (this.passType1 == "password"){
      this.passType1 = "text";
    }else{
      this.passType1 = "password";
    }
  }

  showPwd2(){
    
    if (this.passType2 == "password"){
      this.passType2 = "text";
    }else{
      this.passType2 = "password";
    }
  }

}
